import { useEffect, useRef } from "react";
import { useStoreDispatch } from "../../../../store/hooks";
import { useSelector } from "react-redux";
import { IFilterSelectBox } from "../../../Shared/Filter/types";
import { setAddDeviceGeoRegion, setAddDeviceSiteGroup, setGeoRegion, setSiteGroup } from "../../../../store/filters/profiles/ThresholdCrossingDeviceFilterReducers";
import { IGeoRegion } from "../../../../store/api/admin/types";
import { useRegionDisplay } from "../../../../pages/Administrations/AccessControls/Regions/hooks";
import { AppState } from "../../../../store";
import { addDeviceGeoRegionSelector, addDeviceSiteGroupSelector, geoRegionSelector, siteGroupSelector } from "../../../../store/filters/profiles/ThresholdCrossingDeviceFilterSelectors";
import { getFilter } from "../../../Shared/Association/AssociationHelper";


export const useThresholdDevices = () => {
  const dispatch = useStoreDispatch();
  const siteGroup = useSelector(siteGroupSelector);
  const selectedGeoRegion = useSelector<AppState, IGeoRegion>(geoRegionSelector);

  const { geoRegions } = useRegionDisplay();
  const regionOptions = geoRegions.map((region) => ({ value: region.objectKey, text: region.name }));

  const siteGroups = selectedGeoRegion.name
    ? geoRegions.find((region: IGeoRegion) => region.name === selectedGeoRegion.name)?.siteGroups || []
    : geoRegions.flatMap((region: IGeoRegion) => region.siteGroups || []);

  const siteGroupOptions = Array.from(new Set(siteGroups.map((sg: any) => sg.name)))
    .map((name) => ({ value: name, text: name }));

  const prevGeoRegion = useRef(selectedGeoRegion.objectKey);
  useEffect(() => {
    if (prevGeoRegion.current !== selectedGeoRegion.objectKey) {
      dispatch(setSiteGroup(""));
      prevGeoRegion.current = selectedGeoRegion.objectKey;
    }
  }, [selectedGeoRegion.objectKey, dispatch]);

  const searchFilters: IFilterSelectBox[] = [
    getFilter(
      "geoRegion",
      "All Regions",
      selectedGeoRegion.objectKey,
      setGeoRegion,
      regionOptions,
      "123px"
    ),
    getFilter(
      "group",
      "All Groups",
      siteGroup || "",
      setSiteGroup,
      siteGroupOptions,
      "119px"
    ),
  ];

  // Add 
  const addDeviceSiteGroup = useSelector(addDeviceSiteGroupSelector);
  const selectedAddDeviceGeoRegion = useSelector<AppState, IGeoRegion>(addDeviceGeoRegionSelector);

  const addRegionOptions = geoRegions.map((region) => ({ value: region.objectKey, text: region.name }));

  const addSiteGroups = selectedAddDeviceGeoRegion.objectKey
    ? geoRegions.find((region: IGeoRegion) => region.objectKey === selectedAddDeviceGeoRegion.objectKey)?.siteGroups || []
    : geoRegions.flatMap((region: IGeoRegion) => region.siteGroups || []);

  const addSiteGroupOptions = Array.from(new Set(addSiteGroups.map((siteGroup: any) => siteGroup.name)))
    .map((name) => ({ value: name, text: name }));

  const prevAddGeoRegion = useRef(selectedAddDeviceGeoRegion.objectKey);
  useEffect(() => {
    if (prevAddGeoRegion.current !== selectedAddDeviceGeoRegion.objectKey) {
      dispatch(setAddDeviceSiteGroup(""));
      prevAddGeoRegion.current = selectedAddDeviceGeoRegion.objectKey;
    }
  }, [selectedAddDeviceGeoRegion.objectKey, dispatch]);

  const searchAddFilters: IFilterSelectBox[] = [
    getFilter(
      "addDeviceGeoRegion",
      "All Regions",
      selectedAddDeviceGeoRegion.objectKey,
      setAddDeviceGeoRegion,
      addRegionOptions,
      "123px"
    ),
    getFilter(
      "addDeviceGroup",
      "All Groups",
      addDeviceSiteGroup || "",
      setAddDeviceSiteGroup,
      addSiteGroupOptions,
      "119px"
    ),
  ];

  return {
    searchFilters,
    searchAddFilters
  }
}